import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type WebAliasSlice = {
  webalias: string;
  isLoading: boolean;
};

const initialState = {
  webalias: 'pawtree',
  isLoading: true,
} as WebAliasSlice;

const webaliasSlice = createSlice({
  name: 'webaliasSlice',
  initialState,
  reducers: {
    setWebAlias(state, { payload: webalias }: PayloadAction<string | null>) {
      state.webalias = webalias || 'pawtree';
    },

    setWebAliasLoadingStatus(state, { payload: isLoading }: PayloadAction<boolean>) {
      state.isLoading = isLoading;
    },
  },
});

export const { setWebAlias, setWebAliasLoadingStatus } = webaliasSlice.actions;
export default webaliasSlice;
